import { useState } from "react";
import { availableCategories, productFieldsMapping } from "../../../../Constants/Data";
import { updateProductInformation } from "../../../API_Handler";
import LogoModule from "./ImageModules/LogoModule";
import BannerModule from "./ImageModules/BannerModule";

const ProductsModal = ({ selectedProduct, backgroundColor, defaultExpanded}) => {
    const [product, setProduct] = useState(selectedProduct);
    const [editedProduct, setEditedProduct] = useState(selectedProduct);
    const [expandedProduct, setExpandedProduct] = useState(defaultExpanded);

    const [error, setError] = useState(false);
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmation, setConfirmation] = useState(false);

    const [save, setSave] = useState(false);
    const [cancel, setCancel] = useState(false);

    const handleCategoryToggle = async (category) => {
        setEditedProduct((prev) => {
            const exists = prev.categories.some(c => c.id === String(category.number));
            return {
                ...prev,
                categories: exists
                    ? prev.categories.filter(c => c.id !== String(category.number))
                    : [...prev.categories, { id: String(category.number) }]
            };
        });
    }

    const [changedFields, setChangedFields] = useState({});

    const getChangedFields = () => {
        const changes = {};
        for (const key in product) {
            if (product[key] !== editedProduct[key]) {
                changes[key] = editedProduct[key];
            }
        }
        return changes;
    }

    const handleSave = async () => {
        const changes = await getChangedFields();
        setChangedFields(changes);
        if (Object.keys(changes).length > 0) {
            setConfirmation(true);
            setSave(true);
        }
        setEditing(false);
    }

    const handleCancel = async () => {
        const changes = await getChangedFields();
        setChangedFields(changes);
        if (Object.keys(changes).length > 0) {
            setConfirmation(true);
            setCancel(true);
        }
        setEditing(false);
    }

    const handleConfirm = async () => {
        setLoading(true);
        let changedFields = await getChangedFields();
        let success = await updateProductInformation(selectedProduct.id, changedFields);
        if (success != null) {
            setProduct(success);
            setEditedProduct(success);
            setSave(false);
            setConfirmation(false);
            setEditing(false);
        }
        else {
            setSave(false);
            setError(true);
            setConfirmation(false);
        }
        setLoading(false);
    }

    const handleDiscard = async () => {
        setEditedProduct(product);
        setConfirmation(false);
        setSave(false);
        setCancel(false);
        setEditing(false);
    }

    const handleChangeProductPublishStatus = async (status) => {
        setLoading(true);
        let success = await updateProductInformation(selectedProduct.id, { is_published: status });
        if (success != null) {
            setLoading(false);
            setChangedFields({});
            setProduct(success);
            setEditedProduct(success);
        } else {
            setError(true);
        }
    }

    // const handleLogoUpdate = (newLogoUrl) => {
    //     console.log("newLogoUrl", newLogoUrl);
    //     setEditedProduct({ ...editedProduct, thumbnail: newLogoUrl });
    // }

    // const handleBannerUpdate = (newBannerUrl) => {
    //     console.log("newBannerUrl", newBannerUrl);
    //     setEditedProduct({ ...editedProduct, banner: newBannerUrl });
    // }

    // const getCategoryLabel = (categoryNumber) => {
    //     const category = availableCategories.find(btn => btn.number === parseInt(categoryNumber));
    //     return category ? category.label : categoryNumber.toString();
    // };

    // const getCategoryColor = (categoryNumber) => {
    //     const category = availableCategories.find(btn => btn.number === parseInt(categoryNumber));
    //     return category ? category.background : categoryNumber.toString();
    // };

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
        return new Date(date).toISOString() ? new Date(date).toLocaleString('en-US', options) : 'Invalid date';
    }

    return (
        <div className={`w-full h-fit ${expandedProduct ? "bg-[#fff6e7]" : backgroundColor} flex flex-col border-[1px] border-[#505050] ${expandedProduct ? "border-charmOrange" : "border-transparent"}`}>

            <div className={`w-full ${expandedProduct ? "bg-[#fff6e7]" : backgroundColor} px-[16px] py-[1px] flex flex-row justify-between items-center ${expandedProduct ? "border-b-[1px] border-[#a0a0a0]" : ""}   hover:bg-[#fff6e7]`}>
                <p className="min-w-[60px] max-w-[60px] pr-[16px] font-proximanova text-[18px] text-[#505050] font-[500] border-r-[1px] border-[#a0a0a0] mb-0 cursor-pointer"
                    onClick={() => setExpandedProduct(!expandedProduct)} >
                    {product.id}</p>

                <p className="w-full pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[500] mb-0 cursor-pointer"
                    onClick={() => setExpandedProduct(!expandedProduct)}
                >
                    {product.name}
                </p>

                <div className="flex flex-row justify-between">
                    <div className="w-[168px] flex flex-row items-center border-l-[1px] pl-[16px] border-[#a0a0a0] gap-[8px]">
                        <div className={`w-[8px] h-[8px] rounded-full ${product.is_published === true ? 'bg-[#76da24]' : 'bg-[#bbbbbb]'} `}></div>
                        <p className="w-fit font-proximanova text-[18px] text-[#505050] font-[500] mb-0">{product.is_published === true ? 'PUBLISHED' : 'UNPUBLISHED'}</p>
                    </div>

                    <div className="min-w-[80px] max-w-[80px] border-l-[1px] pl-[16px] border-[#a0a0a0] flex flex-row items-center justify-center">
                        {expandedProduct === false ?
                            (
                                <button className="w-fit flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    onClick={() => setExpandedProduct(true)}
                                >
                                    Expand
                                </button>
                            ) : (
                                <button className="w-fit flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    onClick={() => setExpandedProduct(false)}
                                >
                                    Collapse
                                </button>
                            )}
                    </div>
                </div>
            </div>
            {loading ? (
                <div className="w-full h-fit flex items-center justify-center">
                    {error ? (
                        <div className="w-full py-[16px] flex items-center justify-center">
                            <p className="text-[18px] text-red font-proximanova font-[400] mb-0">Error updating product, please refresh to make sure you are logged in and try again.</p>
                        </div>
                    ) : (
                        <div className="w-full py-[16px] flex items-center justify-center">
                            <span
                                className="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        </div>
                    )}
                </div>
            ) : confirmation ? (
                <div className="w-full h-full flex flex-col overflow-y-auto pb-[16px] px-[16px]">
                    {save ? (
                        <p className="mt-[16px] text-[18px] text-[#fd5764] font-proximanova font-[400] mb-0">Are you sure you want to save these changes?</p>
                    ) : cancel ? (
                        <p className="mt-[16px] text-[18px] text-[#fd5764] font-proximanova font-[400] mb-0">Are you sure you want to discard these changes?</p>
                    ) : ""}

                    <div className="w-full mt-[16px] flex flex-col gap-[8px]">
                        {Object.keys(changedFields).map((key) => (
                            <div className="flex flex-col border-[1px] border-[#999999] p-[8px]" key={key}>
                                <p className="w-full text-[18px] font-proximanova mb-0">{productFieldsMapping[key]}: </p>
                                <p className="w-full text-[18px] font-proximanova mb-0">{product[key]}</p>
                                <div className="w-full flex flex-row">
                                    <p className="ml-[16px] text-left text-[14px] text-[#999999] font-proximanova mb-0">▼</p>
                                </div>
                                <p className="w-full text-[18px] font-proximanova mb-0">{editedProduct[key]}</p>
                            </div>
                        ))}
                    </div>

                    {save ? (
                        <div className="mt-[16px] flex flex-row items-center justify-center gap-4">
                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleConfirm();
                                }}>Save Changes</button>

                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleDiscard();
                                }}>Cancel</button>
                        </div>
                    ) : cancel ? (
                        <div className="mt-[16px] flex flex-row items-center justify-center gap-4">
                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleDiscard();
                                }}>Discard Changes</button>

                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    setConfirmation(false);
                                    setCancel(false);
                                    setEditing(true);
                                }}>Do Not Discard Changes</button>
                        </div>
                    ) : ""}
                </div>

            ) : (
                expandedProduct &&
                <div className="w-full h-full mt-[16px] px-[16px] flex flex-col overflow-y-auto pb-[16px]">
                    <div className={`w-full flex flex-row justify-end ${editing ? "" : "gap-4"}`}>
                        {
                            !editing && (
                                <div className="flex flex-row gap-4">
                                    <button className={`text-white text-[18px] font-proximanova px-[24px] py-[3px] ${loading || product.is_published === true ? 'bg-[#a0a0a0]' : 'bg-[#76da24]'} hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full`}
                                        onClick={() => {
                                            handleChangeProductPublishStatus(true);
                                        }}
                                        disabled={loading || product.is_published === true}
                                    >Publish</button>
                                    <button className={`text-white text-[18px] font-proximanova px-[24px] py-[3px] ${loading || product.is_published === false ? 'bg-[#a0a0a0]' : 'bg-[#fd5764]'} hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full`} onClick={() => {
                                        handleChangeProductPublishStatus(false);
                                    }}
                                        disabled={loading || product.is_published === false}
                                    >Unpublish</button>
                                </div>
                            )
                        }
                        {
                            editing ? (
                                <div className="flex flex-row gap-4" >
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleSave();
                                    }}>Save</button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleCancel();
                                    }}>Cancel</button>
                                </div>
                            ) : (
                                <div className="flex flex-row gap-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => setEditing(true)}>Edit</button>
                                </div>
                            )
                        }
                    </div>

                    {selectedProduct && (
                        <div className="mt-[4px] w-full flex flex-col">
                            <div className="w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Product Name</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.name}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, name: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.name}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Vendor Name</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {product.vendor.company_name}
                                    </p>
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Email for Inquiries</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.contact_email}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, contact_email: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.contact_email}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Website</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="max-w-full w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.website}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, website: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.website}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Description</label>
                            {editing ? (
                                <textarea
                                    className={`w-full h-48 block p-1 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]' : 'border-[1px] border-[#505050] border-white'}`}
                                    value={editedProduct.description}
                                    onChange={(e) => setEditedProduct({ ...editedProduct, description: e.target.value })}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {product.description ? product.description : "No product description available"}
                                </p>
                            )}

                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Features</label>
                            {editing ? (
                                <textarea
                                    className={`w-full h-48 block p-1 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]' : 'border-[1px] border-[#505050] border-white'}`}
                                    value={editedProduct.features}
                                    onChange={(e) => setEditedProduct({ ...editedProduct, features: e.target.value })}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {product.features ? product.features : "No product features available"}
                                </p>
                            )}

                            {/* <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Categories</label>
                            {editing ? (
                                <div className="w-full flex flex-wrap gap-[8px]">
                                    {availableCategories.map((availableCategory, index) => (
                                        <div key={index} className="w-fit rounded-full text-proximanova text-[#5f5f5f] px-3 py-0.5 text-[14px] whitespace-nowrap scrollbar-hide"
                                            style={{ backgroundColor: editedProduct.categories.some(category => category.id === String(availableCategory.number)) ? availableCategory.background : '#efefef' }}
                                            onClick={() => handleCategoryToggle(availableCategory)}
                                        >
                                            {availableCategory.label}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="w-full flex flex-wrap gap-[8px]">
                                    {editedProduct.categories.map((category, index) => (
                                        <div key={index} className="w-fit rounded-full text-proximanova text-[#5f5f5f] px-3 py-0.5 text-[14px] whitespace-nowrap scrollbar-hide"
                                            style={{ backgroundColor: getCategoryColor(category.id) }}
                                        >
                                            {getCategoryLabel(category.id)}
                                        </div>
                                    ))}
                                </div>
                            )} */}

                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Facebook Link</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.facebook}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, facebook: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.facebook ? product.facebook : "No Facebook link available"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Instagram Link</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.instagram}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, instagram: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.instagram ? product.instagram : "No Instagram link available"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">X Link</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.twitter}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, twitter: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.instagram ? product.twitter : "No X link available"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">LinkedIn Link</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.linkedin}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, linkedin: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.linkedin ? product.linkedin : "No LinkedIn link available"}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Pricing URL</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.pricing}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, pricing: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.pricing ? product.pricing : "No Pricing URL available"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Free Version?</label>
                                    {editing ? (
                                        <select
                                            value={editedProduct.has_free_version}
                                            onChange={(e) => setEditedProduct({ ...editedProduct, has_free_version: e.target.value })}
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            disabled={!editing}
                                        >
                                            <option value="" disabled>Free Version?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.has_free_version === true ? "Yes" : "No"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Free Trial?</label>
                                    {editing ? (
                                        <select
                                            value={editedProduct.has_free_trial}
                                            onChange={(e) => setEditedProduct({ ...editedProduct, has_free_trial: e.target.value })}
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            disabled={!editing}
                                        >
                                            <option value="" disabled>Free Trial?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.has_free_trial === true ? "Yes" : "No"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Privacy Policy Link</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px] border-[#505050]"
                                            value={editedProduct.privacy_policy}
                                            onChange={(e) => {
                                                setEditedProduct({ ...editedProduct, privacy_policy: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {product.privacy_policy ? product.privacy_policy : "No Privacy Policy Link available"}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {/* <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Listing Logo</label>
                            <LogoModule
                                initialLogoUrl={editedProduct.thumbnail}
                                editing={editing}
                                onLogoUpdate={handleLogoUpdate}
                            />

                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Listing Banner</label>
                            <BannerModule
                                initialBannerUrl={editedProduct.banner}
                                editing={editing}
                                onBannerUpdate={handleBannerUpdate}
                            /> */}


                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Created</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {product.created_at ? formatDate(product.created_at) : "No Created At available"}
                                    </p>
                                </div>

                                <div className="w-full lg:w-1/4 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Last Updated</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {product.updated_at ? formatDate(product.updated_at) : "No Updated At available"}
                                    </p>
                                </div>

                                <div className="hidden lg:w-1/4 lg:flex flex-col">
                                </div>

                                <div className="hidden lg:w-1/4 lg:flex flex-col">
                                </div>
                            </div>


                        </div>
                    )}
                </div >
            )
            }
        </div >
    );
}

export default ProductsModal;